import { render, staticRenderFns } from "./rechargeFourGird.vue?vue&type=template&id=fb545d2c&scoped=true&"
import script from "./rechargeFourGird.vue?vue&type=script&lang=js&"
export * from "./rechargeFourGird.vue?vue&type=script&lang=js&"
import style0 from "./rechargeFourGird.vue?vue&type=style&index=0&id=fb545d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb545d2c",
  null
  
)

export default component.exports